module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAqCAMAAADlP6mgAAAAAXNSR0IArs4c6QAAADxQTFRFAAAAkra2n5+fkpeclJSZkJWZkpSbkZOZkJSakZOakJSZkZSakZSZkJSakZSZkJSakZOZkZSZkZSakJOZZE6xjAAAABN0Uk5TAAcINjdxdYeIiYqdoLG31vj6/BSiBAcAAADHSURBVDjLhZTZFoMwCAWhSVtjFyz8/7/2IVWzcKmvzszxGAhR9KT3NXrNi9oW6WJqFuqSMZDEdGVCQNWJEJDEtDAh4NABcOou0Ooe0OkzMOgTMOoDMOs94Ogt4OoN4OsHgPQdgHoFuEC9Ag/ThSkAnv+Ay6omKQCIspjeOQCiyP6jsoAvOX81iDSH5Ue64y5OpB8YJzKO3BSZhnaMOGPfR7zF6SL+6jURsLxnBK7/HsEXyC8SXUFFTVIA1EgIEBe1T3iPUn7dvo5ND9rlsgl9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-prev.png
// module id = TgBq
// module chunks = 0